/* @flow */
import * as React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { getActiveDeals } from "../../redux/reducer/deals";
import AddTab from "./AddTab";
import Tab from "./Tab";
import { getViewedStock, TABS_LIMIT } from "../../redux/reducer/tabs";

import type { Dispatch } from "redux";
import type { Action } from "../../redux/action";
import type { State as ReduxState } from "../../redux/reducer";
import type { State as TabsType } from "../../redux/reducer/tabs";
import type { State as StocksType } from "../../redux/reducer/stocks";
import type { State as PointsType } from "../../redux/reducer/points";
import type { State as DealsType } from "../../redux/reducer/deals";

const TabsContainer = React.memo(styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  white-space: nowrap;
`);

const TabContainer = React.memo(styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
`);

type Props = {
  tabs: TabsType,
  deals: DealsType,
  stocks: StocksType,
  points: PointsType,
  time: number,
  dispatch: Dispatch<Action>
};

function Tabs(props: Props) {
  // const shouldShowArrows = props.tabs.tabs.length > 2;
  const shouldShowCloseButton = props.tabs.tabs.length > 1;

  const activeAccount = React.useMemo(() => props.accounts.find(
    account => account.id === props.profile.active_account_id
  ), [props.accounts, props.profile.active_account_id]);

  const Tabs = React.useMemo(() => {
    return props.tabs.tabs.map((tab, index) => (
      <Tab
        key={index}
        id={index}
        tradeMode={props.tradeMode}
        stock={props.stocks[tab]}
        deals={getActiveDeals(tab, props.time, props.deals)}
        points={props.points[tab]}
        time={props.time}
        isActive={index === props.tabs.activeTab}
        onClick={() => {
          props.dispatch({ type: "SET_ACTIVE_TAB", payload: index });
        }}
        onRemoveClick={event => {
          event.stopPropagation();
          props.dispatch({ type: "REMOVE_TAB", payload: index });
          props.dispatch({
            type: "CLEAR_GRAPHICAL_TOOLS",
            payload: {
              activeStock: props.activeStock
            }
          });
        }}
        shouldShowCloseButton={shouldShowCloseButton}
        activeAccount={activeAccount}
      />
    ))
  }, [props.tabs, props.time, props.deals]);

  const nextTabHandler = React.useCallback(
    tab => {
      props.dispatch({ type: "SET_ACTIVE_TAB", payload: tab });
    },
    [],
  );

  const newTabHandler = React.useCallback(stock => {
    props.dispatch({ type: "PUSH_TAB", payload: stock });
  }, []);

  return (
    <TabsContainer>
      <TabContainer>
        {Tabs}
        {props.tabs.tabs.length < TABS_LIMIT && (
          <AddTab
            tabs={props.tabs}
            onNextActiveTab={nextTabHandler}
            onNewTab={newTabHandler}
          />
        )}
      </TabContainer>
    </TabsContainer>
  );
}

function mapStateToProps(state: ReduxState) {
  return {
    tradeMode: state.settings.mode,
    activeStock: getViewedStock(state.tabs),
    tabs: state.tabs,
    deals: state.deals,
    stocks: state.stocks,
    points: state.points,
    time: state.time,
    profile: state.profile,
    accounts: state.accounts
  };
}

export default connect(mapStateToProps)(Tabs);



// WEBPACK FOOTER //
// ./src/components/Tabs/Tabs.js